export function waitFor(store, condition) {
  return () => {
    let unsub;
    return new Promise<void>((resolve) => {
      unsub = store.connect((state) => {
        if (condition(state)) {
          resolve();
        }
      });
    }).then(() => {
      unsub();
    });
  };
}
